<template>
  <div class="import-jobs">
    <div class="add-jobs" v-show="!objectId">
      <div class="close-icon" v-if="search">
        <i @click="search = ''" class="el-icon-close"></i>
      </div>
      <el-input placeholder="Поиск ..." v-model="search" class="input-search">
        <el-button slot="append" icon="el-icon-search"></el-button>
      </el-input>
      <el-table
        row-key="id"
        @row-click="rowClick"
        :row-class-name="rowClassNameObj"
        @select="(e) => handleSelectionChangeObject(e, false)"
        @select-all="(e)  => handleSelectionChangeObject(e, true)"
        empty-text="Объекты не найдены"
        ref="multipleObjectTable"
        :data="filteredList"
        :highlight-current-row="true"
        style="width: 100%"
      >
        <el-table-column
          v-if="!selectOnly"
          property="check"
          type="selection"
          width="55"
        >
        </el-table-column>
        <el-table-column
          property="name"
          label="Объекты"
        >
        </el-table-column>
        <el-table-column
          width="50px"
        >
          <template slot-scope="scope">
            <i v-if="!selectOnly" class="fa fa-edit" @click="selectObject(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="add-jobs" v-show="objectId" v-loading="loading">
      <div class="close-icon" v-if="jobSearch">
        <i @click="jobSearch = ''" class="el-icon-close"></i>
      </div>
      <el-input placeholder="Поиск ..." v-model="jobSearch" class="input-search">
        <el-button slot="append" icon="el-icon-search"></el-button>
      </el-input>
      <div class="jobs-ul">

        <el-table
          @selection-change="handleSelectionChangeJob"
          empty-text="Работы не найдены"
          ref="jobsTable"
          :row-class-name="rowClassName"
          @row-click="rowClickJob"
          @select-all="selectAllJobs"
          :data="filteredJobs"
          style="width: 100%"
        >
          <el-table-column
            v-if="!selectOnly"
            property="check"
            type="selection"
            width="55"
          ></el-table-column>
          <el-table-column
            label="Работы"
          >
            <template slot-scope="scope">
              <div>
                <div class="name-slot">
                  <span>{{ scope.row.name }}, {{scope.row._data.unit}}</span>
                  <strong v-if="!selectOnly && Number(scope.row._data.plan)" class="precent" :style="{color: pStatus(findPercentage(scope.row._data.totalValue, scope.row._data.plan))}">
                    {{ findPercentage(scope.row._data.totalValue, scope.row._data.plan) }}%
                  </strong>
                </div>
                <div v-if="!selectOnly">
                  <el-input v-model="scope.row.currentPlan" @input="(e) => savePlanChange(e, scope.row)"
                            @focus="scope.row.isModify = true"></el-input>
                </div>
                <div v-if="!selectOnly" class="analytic-row">
                  <span style="margin-right: 8px">План: <strong>{{
                      toFixedWithoutZero(scope.row._data.plan || 0)
                    }}</strong></span>
                  <span style="margin-right: 8px">Факт: <strong>{{
                      toFixedWithoutZero(scope.row._data.totalValue || 0)
                    }}</strong></span>
                  <span style="margin-right: 8px">+\-: <strong>{{
                      (toFixedWithoutZero((scope.row._data.totalValue || 0) - (scope.row._data.plan || 0)))
                    }}</strong></span>
                  <!--                  -->
                  <!--                  <strong>План: {{ scope.row._data.plan || 0 }}</strong>-->
                  <!--                  <strong>Факт: 0</strong>-->
                  <!--                  <strong>+\- 0</strong>-->
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="create-footer">
      <el-button @click="back" v-if="objectId">Назад</el-button>
      <el-button @click="save" type="primary" :loading="loading" v-if="!selectOnly">Сохранить</el-button>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase';
import _ from 'lodash';
import {getChildList} from '../../../../utils/getChild';
import {v4 as uuidv4} from 'uuid';
import {getPermission, getPermissionByUser} from "../../../../firestore/permission";
import {filterObjects, filterJobs} from "../../../../utils/filterJobs";
import {toFixedWithoutZero} from "../../../../utils/numberUtils";

const dayjs = require('dayjs');
dayjs.extend(require('dayjs/plugin/customParseFormat'));
dayjs.extend(require('dayjs/plugin/duration'));

export default {
  name: 'PermissionJobsWorkObject',
  props: ['name', 'onlyPlan', 'id', 'planId', 'versionId', 'selectOnly', 'allPlan', 'dates', 'selectCompanies'],
  data() {
    return {
      search: '',
      jobSearch: '',
      lastPosition: null,
      dialogObject: false,
      objectId: null,
      selectedObjects: [],
      loader: false,
      currentPlanChange: {},
      selectedJob: [],
      loading: false,
      availableJobs: {},
      permission: {},
      permissionUser: {
        available_objects: null
      },
      availableObjects: [],
      list: [],
      jobs: [],
    };
  },
  computed: {
    filteredList() {
      let isAll = true
      if (this.selectCompanies) {
        isAll = !this.selectCompanies.find(({_data}) => _data.usePermission)
      }

      if (isAll) {
        return this.list
      } else {
        const allObjects = []
        this.selectCompanies.forEach(({_data}) => {

          if (_data.available_objects) {
            _data.available_objects.forEach((id) => {
              allObjects.push(id)
            })
          }
        })

        return filterObjects(this.list, {available_objects: allObjects})
      }
    },
    filteredJobs() {
      let filteredJobs = [...this.jobs];

      if (this.onlyPlan) {
        filteredJobs = filteredJobs.filter(({_data}) => !!_data.plan)
      }

      if (this.allPlan) {
        filteredJobs = filteredJobs.map((job) => {


          if (job.isModify) {
            return job
          }
          let currentPlan = toFixedWithoutZero((job._data.plan || 0) - (job._data.totalValue || 0));

          return {
            ...job,
            currentPlan: currentPlan > 0 ? currentPlan : ''
          }
        })
      } else {
        filteredJobs = filteredJobs.map((job) => {
          if (job.isModify) {
            return job
          }

          let currentPlan = ''

          if (job._data.start_date && job._data.end_date && this.dates && this.dates[0] && this.dates[1]) {
            currentPlan = this.calculateWorkPlan(this.dates[0], this.dates[1], job._data.start_date, job._data.end_date, job._data.plan || 0)
          }

          return {
            ...job,
            currentPlan: currentPlan
          }
        })
      }

      return filteredJobs
      //   .filter(object => {
      //   return object.name.toLowerCase().includes(this.jobSearch.toLowerCase());
      // }) || [];
    },
  },

  watch: {
    allPlan() {
      this.currentPlanChange = {}
    },
    filteredList: _.debounce(function () {
      this.filteredList.map((row) => {
        const availableObjects = this.availableObjects.map((a) => a.id);
        const selectedObjects = this.selectedObjects.map((a) => a.id);

        if (availableObjects.includes(row.id) || selectedObjects.includes(row.id)) {
          this.$refs.multipleObjectTable.toggleRowSelection(row);
        }
      })
    }, 200),
    filteredJobs: _.debounce(function () {
      const objectIsSelect = !!this.selectedObjects.find(({id}) => id === this.objectId)

      this.filteredJobs.map((row) => {
        const availableJobs1 = (this.availableJobs[this.objectId] || []).map((a) => a.id);

        if (availableJobs1.includes(row.id) || (objectIsSelect)) {
          this.$refs.jobsTable.toggleRowSelection(row);
        }
      })
    }, 500)
  },

  async mounted() {
    this.permission = await getPermission(this.$store.state.project.id, this.$store.state.company.uid || authFirestore.currentUser.uid, (this.$store.state.project.plan && this.$store.state.project.plan.id), undefined, true);
    if (!this.$store.state.project.version && !this.permission.usePermission) {
      this.permissionUser = await getPermissionByUser(this.$store.state.project.id, authFirestore.currentUser.uid, this.$store.state.project.plan && this.$store.state.project.plan.id);
    }
    this.fetchTree();
  },

  methods: {
    rowClassNameObj({row}) {
      if(this.search && !row.name.toLowerCase().includes(this.search.toLowerCase())) {
        return 'hide-row'
      }

      return  ''
    },
    rowClassName({row, rowIndex}) {


      if(this.onlyPlan && !row.currentPlan && !this.currentPlanChange[row.id]) {
        return 'hide-row'
      }

      if(!row.currentPlan && this.currentPlanChange[row.id]) {
        row.currentPlan = this.currentPlanChange[row.id]
      }


      if(this.jobSearch && !row.name.toLowerCase().includes(this.jobSearch.toLowerCase())) {
        return 'hide-row'
      }

      return  ''
    },
    calculateWorkPlan(rangeStart, rangeEnd, planStart, planEnd, totalWork) {
      const rangeStartDate = dayjs(rangeStart);
      const rangeEndDate = dayjs(rangeEnd);
      const planStartDate = dayjs(planStart);
      const planEndDate = dayjs(planEnd);

      if (!rangeStartDate.isValid() || !rangeEndDate.isValid() || !planStartDate.isValid() || !planEndDate.isValid()) {
        return ""
      }

      const actualStartDate = rangeStartDate.isAfter(planStartDate) ? rangeStartDate : planStartDate;
      const actualEndDate = rangeEndDate.isBefore(planEndDate) ? rangeEndDate : planEndDate;

      const actualDurationDays = actualEndDate.diff(actualStartDate, 'day') + 1;
      const totalDurationDays = planEndDate.diff(planStartDate, 'day') + 1;

      if (actualDurationDays <= 0 || totalDurationDays <= 0) {
        return ''
      }

      const workPlan = (totalWork * actualDurationDays) / totalDurationDays;
      return parseFloat(workPlan.toFixed(2));
    },
    savePlanChange(e, row) {
      row.currentPlan = e
      this.currentPlanChange[row.id] = row.currentPlan
    },
    toFixedWithoutZero,
    pStatus(n) {
      if (n >= 99) {
        return '#7CB342'
      }

      if (n > 85) {
        return '#F57C00'
      }

      return '#D32F2F'
    },
    findPercentage(a, b) {
      if (!a) {
        return 0
      }

      if (!b) {
        return 100
      }


      return Number((Number(a || 0) / Number(b)) * 100).toFixed(0);
    },
    rowClickJob(selected) {
      if (this.selectOnly) {
        this.$emit('select-job', selected)
        this.close()
      }
    },
    rowClick(selected) {
      if (this.selectOnly) {
        this.objectId = selected.id;
        this.fetchJobs();
      }
    },
    fire() {
      if (this.$store.state.project.plan && this.$store.state.project.plan.id) {
        return myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('plan')
          .doc(this.planId)
      }

      if (this.$store.state.project.version && this.$store.state.project.version.id) {
        return myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('versions')
          .doc(this.versionId)
      }

      return myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
    },
    selectObject({id}) {
      this.objectId = id;
      this.fetchJobs();
    },
    back() {
      this.objectId = null;
    },
    fetchTree() {
      this.loader = true;
      const result = [];
      this.fire()
        .collection('objects')
        .get()
        .then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              id: subDoc.id,
              name: data.name,
              objects: data.objects,
              index: data.index,
              parentId: data.parentId || undefined,
              isParent: data.isParent,
            });
          });
        }).finally(() => {
        this.list = [
          {
            id: 'all',
            name: 'Корневой каталог',
            index: 0,
            isParent: true,
          },
          ..._.orderBy(filterObjects(filterObjects(getChildList(result), this.permission), this.permissionUser), 'index', ['asc'])
        ];
        this.loader = false;
      }).catch((e) => {
        console.error(e)
        this.loader = false;
      });
    },
    async save() {
      this.loading = true;
      const availableJobs = this.availableJobs;
      const availableObjects = this.availableObjects

      const objects = []

      for (let object of availableObjects.filter((obj, index, self) =>
          index === self.findIndex((t) => (
            t.id === obj.id
          ))
      )) {

        const uid = uuidv4()
        const jobs = await this.fetchJobs(true, object.id, uid)
        let t = []
        jobs.forEach((job) => {
          if(!availableJobs[object.id] || availableJobs[object.id].find(({id}) => id === job.job.id) ) {

            let plan = ''
            if (this.currentPlanChange[job.job.id]) {
              plan = this.currentPlanChange[job.job.id]
            } else if (!this.allPlan && !(this.dates && this.dates[0] && this.dates[1])) {
              plan = ''
            } else if (this.allPlan) {
              let currentPlan = toFixedWithoutZero((job.job.plan || 0) - (job.job.totalValue || 0));
              plan = currentPlan > 0 ? currentPlan : ''
            } else if (this.dates && this.dates[0] && this.dates[1] && job.job.start_date && job.job.end_date) {
              plan = this.calculateWorkPlan(this.dates[0], this.dates[1], job.job.start_date, job.job.end_date, job.job.plan || 0)
            }

            job.plan = plan

            if(this.onlyPlan) {
              if(job.plan) {
                t.push(job)
              }
            } else {
              t.push(job)
            }

          }
        })

        objects.push({
          id: uid,
          mainId: object.id,
          index: object.name === 'Корневой каталог' ? null : object.index,
          name: object.name === 'Корневой каталог' ? '' : object.name,
          jobs: t,
          isSelect: true,
        })
        delete availableJobs[object.id]
      }

      const mainJobs = []

      Object.values(availableJobs).map((r) => {
        r.filter((obj, index, self) =>
            index === self.findIndex((t) => (
              t.id === obj.id
            ))
        ).forEach(({_data, id}) => {
          let plan = ''
          if (this.currentPlanChange[id]) {
            plan = this.currentPlanChange[id]
          } else if (!this.allPlan && !(this.dates && this.dates[0] && this.dates[1])) {
            plan = ''
          } else if (this.allPlan) {
            let currentPlan = toFixedWithoutZero((job._data.plan || 0) - (job._data.totalValue || 0));
            plan = currentPlan > 0 ? currentPlan : ''
          } else if (this.dates && this.dates[0] && this.dates[1] && _data.start_date && _data.end_date) {
            plan = this.calculateWorkPlan(this.dates[0], this.dates[1], _data.start_date, _data.end_date, _data.plan || 0)
          }


          if(this.onlyPlan) {
            if(plan) {
              mainJobs.push({..._data, plan: plan})
            }
          } else {
            mainJobs.push({..._data, plan: plan})
          }
        })
      })


      if (mainJobs.length) {
        objects.push({
          id: null,
          index: null,
          name: null,
          parentId: null,
          jobs: mainJobs,
        })
      }



      this.$emit('update', objects);
      this.loading = false;

      if (this.objectId) {
        return this.objectId = null;
      } else {
        this.close();
      }
      // });
    },
    close() {
      this.dialogObject = false;
      this.loading = false;
      this.clear();
    },
    clear() {
      this.objectId = null;
      this.selectedJob = [];
      this.selectedObjects = [];
      this.loading = false;

      this.search = '';
    },
  },
};
</script>

<style lang="scss">
.hide-row {
  display: none;
}
</style>
<style scoped lang="scss">

.add-jobs {
  display: flex;
  flex-direction: column;

  .jobs-ul {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 8px;
  }

  .jobs-li {
    padding: 0 10px;
    width: calc(100% - 20px);
    justify-content: flex-start;
    height: 48px;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);

    &.link {
      display: flex;
      justify-content: center;
      margin-top: 10px;

      a {
        color: #3676CB;
        text-decoration: none;
      }

      &:hover {
        background: rgba(0, 0, 0, 0);
      }
    }

    &:hover {
      background: #eee;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .select-value {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;

    .input-with-select {
      margin-top: 12px;
    }

    > > > {
      .el-select .el-input {
        width: 142px;
      }
    }
  }
}

.create-footer {
  margin-top: 22px;
  display: flex;
  justify-content: space-between;
}

.jobs-core {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding: 15px 15px;
}

.name-slot {
  display: flex;
  justify-content: space-between;
}

.red {
  color: #cc3700;
}

.close-icon {
  position: relative;
  margin: 0 74px 0 auto;
  cursor: pointer;
  top: 30px;
  z-index: 9;
}

.analytic-row {
  display: flex;

  strong {
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/ReportsOne/components/PermissionJobsWorkObject.vue